import * as React from 'react';
import { SVGProps } from 'react';

const FileIconBmpSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 14H6v6.667L9 18l6.5 6H18V14H6.5ZM6 23.5v-1.167l3-2.81L14 24H6v-.5Zm-1-9V25h14V13H5v1.5Zm8 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8.77c.22.153.487.23.8.23h.5c.587 0 1.017-.123 1.29-.37.273-.253.41-.663.41-1.23V5.6c0-.56-.137-.967-.41-1.22C8.31 4.127 7.82 4 7.24 4H6V2H5v7h1v-.23ZM6.65 8c-.22 0-.383-.057-.49-.17A.566.566 0 0 1 6 7.45V5h1.25c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-.6Z"
      fill="#fff"
    />
    <path
      d="M11.5 4c.384 0 .735.144 1 .382a1.5 1.5 0 0 1 2.497 1.026L15 5.41V9h-1V5.5a.5.5 0 0 0-1 0V9h-1V5.5a.5.5 0 0 0-1 0V9h-1V4h.8v.173c.209-.11.447-.173.7-.173Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8 4.24V4H16v7h1.01V9h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V5.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24L17 5.55a.53.53 0 0 1 .16-.37Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconBmpSizeS;
